import { useSelector } from 'react-redux';
import type { OrderId } from 'shared/domain';
import type { StoreAuditGlobalState } from '../../models';
import { STORE_AUDIT_SLICE_NAME } from './storeAudit.const';

const _getState = (s: any): StoreAuditGlobalState => s[STORE_AUDIT_SLICE_NAME];

export const storeAuditSelector = {
  selectAll: () => useSelector((s: any) => _getState(s)),
  selectById: (orderId: OrderId) =>
    useSelector((s: any) => _getState(s)).find(x => x.orderId === orderId),
};
